import React from 'react'
import { InputUI } from '../../ui'
import { Radio } from '../../ui/Radio'
import { InfoTooltip } from '../InfoTooltip/InfoTooltip'
import * as S from './Option.styled'
import type { OptionProps } from './types'

export const Option = ({
  name,
  label,
  tooltip,
  value,
  checked,
  suggestion,
  disabled,
  tabIndex,
  inputRef,
  onChange,
  onBlur,
}: OptionProps) => {
  const renderTooltip = () => {
    if (!tooltip) return null

    return (
      <S.TooltipContainer>
        <InfoTooltip content={tooltip} />
      </S.TooltipContainer>
    )
  }

  return (
    <S.Container>
      <div>
        <Radio
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          tabIndex={tabIndex}
          inputRef={inputRef}
          onChange={onChange}
          onBlur={onBlur}
        />
      </div>
      <S.LabelContainer>
        <S.Label disabled={disabled}>
          {label}
          {renderTooltip()}
        </S.Label>
        {suggestion && <InputUI.Suggestion $withoutMargin>{suggestion}</InputUI.Suggestion>}
      </S.LabelContainer>
    </S.Container>
  )
}
